import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createLocator } from '../../services/locatorManagementService';

export const createLocatorAsync = createAsyncThunk(
  'locatorManagement/create',
  async ({ _isClone, ...payload }, { rejectWithValue }) => {
    try {
      return await createLocator(payload);
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Save failed.');
    }
  },
);

const createLocatorSlice = createSlice({
  name: 'createLocator',
  initialState: { loading: false, error: null, successMsg: null },
  reducers: {
    clearMessages(state) {
      state.error = null;
      state.successMsg = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLocatorAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMsg = null;
      })
      .addCase(createLocatorAsync.fulfilled, (state, action) => {
        state.loading = false;
        const { _isClone, locator_name, build } = action.meta.arg;
        state.successMsg = _isClone
          ? `Cloned "${locator_name}" for build ${build}.`
          : `"${locator_name}" created for build ${build}.`;
      })
      .addCase(createLocatorAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMessages } = createLocatorSlice.actions;
export const selectCreateLoading = (state) => state.createLocator.loading;
export const selectCreateError = (state) => state.createLocator.error;
export const selectCreateSuccessMsg = (state) => state.createLocator.successMsg;
export default createLocatorSlice.reducer;
